import * as dotenv from "dotenv";

import HomeHover from "../assets/images/home-hover.svg";
import HomeSelected from "../assets/images/home-selected.svg";
import AddNetworkResourceHover from "../assets/images/add-network-resource-hover.svg";
import AddNetworkResourceSelected from "../assets/images/add-network-resource-selected.svg";
import ManageAssetsHover from "../assets/images/manage-assets-hover.svg";
import ManageAssetsSelected from "../assets/images/manage-assets-selected.svg";
import MarketPlaceHover from "../assets/images/marketplace-hover.svg";
import MarketPlaceSelected from "../assets/images/marketplace-selected.svg";
import CanvasViewIcon from "../assets/images/canvas-view.svg";
import CanvasViewSelectedIcon from "../assets/images/canvas-view-selected.svg";
import MapViewIcon from "../assets/images/map-view.svg";
import MapViewSelectedIcon from "../assets/images/map-view-selected.svg";
import ValidationHover from "../assets/images/validation-hover.svg";
import ValidationSelected from "../assets/images/validation-selected.svg";
import WXPayHover from "../assets/images/wx-pay-hover.svg";
import WXPaySelected from "../assets/images/wx-pay-selected.svg";
import AboutHover from "../assets/images/about-hover.svg";
import AboutSelected from "../assets/images/about-selected.svg";
import AddPort from "../assets/images/add-port.svg";
import ManagePort from "../assets/images/manage-port.svg";
import BuyPort from "../assets/images/buy-port.svg";
import AddBandwidth from "../assets/images/add-bandwidth.svg";
import ManageBandwidth from "../assets/images/manage-bandwidth.svg";
import BuyBandwidth from "../assets/images/buy-bandwidth.svg";
import { Roles, AuthRoutes } from "../enums";
import CSVIcon from "../assets/images/csv-file-icon.svg";
import summaryIcon from "../assets/images/summaryIcon.svg";

dotenv.config();

type titleSub = { title: string; subtitle: string };
type dateCell = { start: Date; end: Date | null };
export type priceRowType = {
  type: "income" | "expense";
  mrc: number;
  fee: number;
  targetOrg: string;
  mrcAvg: number;
  row?: {
    description: titleSub;
    location: titleSub;
    targetOrg: titleSub;
    term: { type: "contract" | "demand" | "fee" | "MRC"; charge: number; quantity: number };
    dates: dateCell;
    resourceId?: string;
    boughtResource?: boolean;
    groupId: number;
    id: number;
    priority: number;
  };
};
// mapping database price_type rows to what we want to display to users
const serviceList = [
  "Initial Port Verification",
  "Cancelled",
  "on_contract (node)",
  "on_contract (nearend node)",
  "on_contract (farend node)",
  "on_demand (node)",
  "on_demand (farend node)",
  "on_demand (nearend node)",
  "on_contract (seller)",
  "on_demand (seller)",
  "Sold (node)",
  "Sold (nearend node)",
  "Sold (farend node)",
  "Sold (seller)",
  "Added",
  "Occupancy Charge",
];
const displayServiceList = {
  purchaseInMarketplace: "Purchase In Marketplace",
  soldInMarketplace: "Sold In Marketplace",
  initialPortVerification: "Move To WX/Meet-me room",
  portRemoved: "Port Removed",
  crossConnectCharge: "Cross Connect Fee",
  portOnSwitch: "WaveXchange Fee",
};

const serviceLookup = {
  // Fees (income and expense)
  "Initial Port Verification": displayServiceList.initialPortVerification,
  Cancelled: displayServiceList.portRemoved,

  // Buyer to node (expense)
  "on_contract (node)": displayServiceList.crossConnectCharge,
  "on_contract (nearend node)": displayServiceList.crossConnectCharge,
  "on_contract (farend node)": displayServiceList.crossConnectCharge,
  "on_demand (node)": displayServiceList.crossConnectCharge,
  "on_demand (farend node)": displayServiceList.crossConnectCharge,
  "on_demand (nearend node)": displayServiceList.crossConnectCharge,

  // Buyer to seller (expense)
  "on_contract (seller)": displayServiceList.purchaseInMarketplace,
  "on_demand (seller)": displayServiceList.purchaseInMarketplace,

  // Node to buyer (income)
  "Sold (node)": displayServiceList.crossConnectCharge,
  "Sold (nearend node)": displayServiceList.crossConnectCharge,
  "Sold (farend node)": displayServiceList.crossConnectCharge,

  // Seller to buyer (income)
  "Sold (seller)": displayServiceList.soldInMarketplace,

  // MRC (income and expense)
  Added: displayServiceList.portOnSwitch,
  "Occupancy Charge": displayServiceList.crossConnectCharge,
};
export const termLookup = {
  contract: "24 Months",
  MRC: "Recurring Charge",
  demand: "On Demand",
  fee: "Non Recurring Charge",
  "": "",
};
export const NEW_GROUP_DROPDOWN = "+ Add New Group" + "\u2003";

export const NODE_CONSTANTS = {
  WIDTH: {
    MAX: 6000 ,
    MIN: 300,
    DEFAULT: 400,
  },
  HEIGHT: {
    MAX: 4000,
    MIN: 300,
    DEFAULT: 400,
  },
  PERIMETER_THICKNESS: 40,
  MAX_CHARS_FOR_WIDTH: {
    400: 15,
    // 500:
  },
};
export const lookupService = (lookup: string): string => {
  const service = lookup.trim();
  if (serviceList.findIndex((ser: string) => ser === service) !== -1) {
    // @ts-ignore
    return serviceLookup[service];
  }
  return service;
};
export const rankService = (lookup: string): number => {
  const serviceName = lookupService(lookup);
  if (serviceName === displayServiceList.soldInMarketplace || serviceName === displayServiceList.purchaseInMarketplace) return 1;
  return 0;
};
export type summaryRowType = {
  company: string;
  currentBillingPeriod: number;
  monthlyRecurring: number;
  total?: boolean;
};
export type csvPriceRowType = {
  id: number;
  resourceId: string | null;
  description: string;
  location: string;
  provider: string;
  service: string;
  price: string;
  term: string;
  quantity: number | string;
  startDate: string;
  endDate: string;
  perMonth: string;
  filterStartDate: string;
  filterEndDate: string;
  total: string;
};

export const RegistrationFieldsMapping = {
  fname: "fname",
  lname: "lname",
  uname: "uname",
  email: "email",
  contact: "contact",
  company: "company",
  password: "password",
  confirmPassword: "confirmPassword",
  address: "address",
  country: "country",
  state: "state",
  city: "city",
  zip: "zip",
};
export const PrivateNodeRegistrationFieldsMapping = {
  fname: "fname",
  lname: "lname",
  uname: "uname",
  email: "email",
  contact: "contact",
  company: "company",
  password: "password",
  confirmPassword: "confirmPassword",
  address: "address",
  country: "country",
  state: "state",
  city: "city",
  zip: "zip",
};
export const PrivateNodeFieldsMapping = {
  fname: "fname",
  lname: "lname",
  uname: "uname",
  email: "email",
  contact: "contact",
  company: "company",
  address: "address",
  country: "country",
  state: "state",
  city: "city",
  zip: "zip",
};
export const RequestQuoteFieldsMapping = {
  fname: "fname",
  lname: "lname",
  email: "email",
  contact: "contact",
  address: "address",
  address2: "address2",
  country: "country",
  state: "state",
  city: "city",
  zip: "zip",
  company: "company",
  title: "title",
};

export const LoginFieldsMapping = {
  userId: "userId",
  password: "password",
};

export const EditPortFieldMapping = {
  portName: "portName",
  portDescription: "portDescription",
};

export const EditBandwidthFieldMapping = {
  portNameNE: "ne_port",
  portDescriptionNE: "ne_desc",
  portNameFE: "fe_port",
  portDescriptionFE: "fe_desc",
  description: "description",
};

export const VerifyPopupMapping = {
  position: "position",
};

export const MAX_NO_PORTS_ALLOWED = 50;
export const ErrorMessages = {
  register: {
    passwordsNotMatch: "Password and Confirm Password should match.",
    emailNotValid: "Please enter valid Email.",
  },
  addPort: {
    noOfPortsMinLimit: "Min value allowed is 1.",
    noOfPortsMaxLimit: "Min value allowed is " + MAX_NO_PORTS_ALLOWED + ".",
    noOfPortsRequired: "No. of Port to be added is required.",
  },
  addBandwidth: {
    noOfLinksMinLimit: "Min value allowed is 1.",
    noOfPortsMaxLimit: "Min value allowed is " + MAX_NO_PORTS_ALLOWED + ".",
    noOfLinksRequired: "No. of Links to be added is required.",
  },
};

export const TableConstants = {
  perPage: 12,
  wxPayPerPage: 12,
  bandwidthPortsPerPage: 12,
  noRecordsFound: "No records to display",
};

export const Regex = {
  email: /^([a-zA-Z0-9_\.\-+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/,
  numbers: /^[0-9]+$/,
};
export const YearDaysForCalculation = 365.25;
export const ArrayOfCharactersNotAllowedInNumericField = ["e", "E", "+", "-", "."];
export const ArrayOfCharactersNotAllowedInNumericFloatField = ["e", "E", "+", "-"];
export const DefaultRxTxValue = 0;
export const defaultPortName = "default-port-naming-convention";
export interface HeadCellType {
  disablePadding: boolean;
  id: string;
  align: "left" | "right" | "center";
  sortEnabled: boolean;
  width: string;
  label?: string;
  searchEnabled?: boolean;
  tooltipTitle?: string;
  tooltipPlacement?:
    | "bottom-end"
    | "bottom-start"
    | "bottom"
    | "left-end"
    | "left-start"
    | "left"
    | "right-end"
    | "right-start"
    | "right"
    | "top-end"
    | "top-start"
    | "top";
}

export const ZOOM_CONSTANTS = {
  DefaultScale: 80, // canvas defaults to this scale
  maxScale: 300, // canvas is upper bounded by this scale
  minScale: 10, // canvas is lower bounded *^
  step: 5, // relates to ZoomControl buttons
  scrollSpeed: 1.5, // relates to the speed at which a mousewheel zooms in/out the canvas
};

export interface DropdownOptions {
  text: string;
  value: any;
}

export interface ChildMenuType {
  text: string;
  icon?: any;
  redirectsTo?: string;
}

export interface MenuType {
  text: string;
  id?: string;
  icon: any;
  selectedIcon: any;
  disabled: boolean;
  accessibleTo: Roles;
  redirectsTo?: AuthRoutes;
  childMenus?: ChildMenuType[];
}

export const MenuTextMapping = {
  home: "home",
  addNetworkResource: "addNetworkResource",
  validation: "validation",
  marketplace: "marketplace",
  manageAssets: "manageAssets",
  wxPay: "wxPay",
  about: "about",
  account: "account",
};

export const Menus: MenuType[] = [
  {
    text: "My Network",
    id: MenuTextMapping.home,
    icon: HomeHover,
    selectedIcon: HomeSelected,
    disabled: true,
    accessibleTo: Roles.user,
    // redirectsTo: AuthRoutes.dashboard,
    childMenus: [
      {
        text: "Canvas View",
        icon: CanvasViewIcon,
        redirectsTo: AuthRoutes.dashboard,
      },
      {
        text: "Map View",
        icon: MapViewIcon,
        redirectsTo: AuthRoutes.myNetworkMapView,
      },
    ],
  },
  {
    text: "Manage Resources",
    icon: ManageAssetsHover,
    selectedIcon: ManageAssetsSelected,
    id: MenuTextMapping.manageAssets,
    disabled: true,
    accessibleTo: Roles.user,
    childMenus: [
      {
        text: "Manage Ports",
        icon: ManagePort,
        redirectsTo: AuthRoutes.managePorts,
      },
      {
        text: "Manage Links",
        icon: ManageBandwidth,
        redirectsTo: AuthRoutes.manageBandwidth,
      },
      {
        text: "Host A Private Node",
        icon: AboutHover,
        redirectsTo: AuthRoutes.privateNode
      },
      {
        text: "View Private Node Status",
        icon: AboutHover,
        redirectsTo: AuthRoutes.privateNodeRequestStatus
      }
    ],
  },
  {
    text: "MarketPlace",
    icon: MarketPlaceHover,
    selectedIcon: MarketPlaceSelected,
    id: MenuTextMapping.marketplace,
    disabled: true,
    accessibleTo: Roles.user,
    childMenus: [
      {
        text: "Buy Services",
        icon: BuyPort,
        redirectsTo: AuthRoutes.marketPlacePorts,
      },
      {
        text: "Buy Links",
        icon: BuyBandwidth,
        redirectsTo: AuthRoutes.marketPlaceBandwidthMap,
      },
    ],
  },
  {
    text: "WX Pay",
    icon: WXPayHover,
    selectedIcon: WXPaySelected,
    id: MenuTextMapping.wxPay,
    disabled: true,
    accessibleTo: Roles.user,
    // redirectsTo: AuthRoutes.wxPay,
    childMenus: [
      {
        text: "Summary",
        icon: summaryIcon,
        redirectsTo: AuthRoutes.wxPay,
      },
      {
        text: "Reports",
        icon: CSVIcon,
        redirectsTo: AuthRoutes.reports,
      },
    ],
  },
  {
    text: "Validation",
    icon: ValidationHover,
    selectedIcon: ValidationSelected,
    disabled: true,
    id: MenuTextMapping.validation,
    accessibleTo: Roles.admin,
    childMenus: [
      {
        text: "New User",
        redirectsTo: AuthRoutes.userVerification,
      },
      {
        text: "Physical Validation",
        redirectsTo: AuthRoutes.portVerification,
      },
      {
        text: "Cross Connect",
        redirectsTo: AuthRoutes.crossConnectValidation,
      },
      {
        text: "Delete Ports",
        redirectsTo: AuthRoutes.deletePorts,
      },
      {
        text: "Admin Scripts",
        redirectsTo: AuthRoutes.adminScripts,
      },
    ],
  },
  {
    text: "Account",
    icon: AboutHover,
    selectedIcon: AboutSelected,
    disabled: false,
    id: MenuTextMapping.about,
    accessibleTo: Roles.user,
    redirectsTo: AuthRoutes.account,
  },
  {
    text: "About WaveXchange",
    icon: AboutHover,
    selectedIcon: AboutSelected,
    disabled: false,
    id: MenuTextMapping.about,
    accessibleTo: Roles.admin,
    redirectsTo: AuthRoutes.about,
  },
];

export const RolesTextMapping: any = {
  [Roles.admin]: "Admin",
  [Roles.user]: "Enterprise User",
};

export const RolesDropdown: DropdownOptions[] = [
  {
    text: "Admin",
    value: Roles.admin,
  },
  {
    text: "Enterprise User",
    value: Roles.user,
  },
];

export const priceFilterDropdown: DropdownOptions[] = [
  {
    text: "Both",
    value: "both",
  },
  {
    text: "On Contract",
    value: "oncontract",
  },
  {
    text: "On Demand",
    value: "ondemand",
  },
];
export const priceFilterArray: string[] = ["On Contract", "On Demand"];
export const AVERAGE_MINUTES_IN_MONTH = 43830;
export const RoutesMapping = {
  [MenuTextMapping.home]: [AuthRoutes.dashboard],
  [MenuTextMapping.addNetworkResource]: [AuthRoutes.addPort, AuthRoutes.addBandwidth],
  [MenuTextMapping.marketplace]: [AuthRoutes.marketPlacePorts, AuthRoutes.marketPlaceBandwidth],
  [MenuTextMapping.validation]: [
    AuthRoutes.userVerification,
    AuthRoutes.portVerification,
    AuthRoutes.bandwidthVerification,
    AuthRoutes.crossConnectValidation,
    AuthRoutes.deletePorts,
    AuthRoutes.deleteBandwidthPorts,
  ],
  [MenuTextMapping.wxPay]: [AuthRoutes.wxPay],
  [MenuTextMapping.about]: [AuthRoutes.about],
  [MenuTextMapping.manageAssets]: [AuthRoutes.managePorts, AuthRoutes.manageBandwidth],
};

// export const PURCHASE_PORT_CHARGE_PER_MONTH = process.env.REACT_APP_PURCHASE_PORT_CHARGE_PER_MONTH ? parseInt(process.env.REACT_APP_PURCHASE_PORT_CHARGE_PER_MONTH) : 0;
const CROSS_CONNECT_CHARGE_PER_MONTH = 350;
const CROSS_CONNECT_CHARGE_PER_MONTH_OFF_NET = 400;
export const getPortChargePerMonth = (obj: any) => {
  if (obj?.listing_verified === 1) return CROSS_CONNECT_CHARGE_PER_MONTH;
  if (obj?.listing_verified === 0) return CROSS_CONNECT_CHARGE_PER_MONTH_OFF_NET;
  return CROSS_CONNECT_CHARGE_PER_MONTH;
};

export const PORT_NAME_PREFIX = {
  GROUP_ID: "GROUP_ID_",
  PORT_ID: "PORT_ID_",
  PURCHASE_PORT_ID: "PURCHASE_PORT_ID_",
};

export const STATUS_TYPE = {
  FOR_SALE_PORT: "port_put_up_for_sale",
  BOUGHT_PORT: "bought_port",
  FOR_SALE_BW: "put_up_for_sale_bandwidth",
  BOUGHT_BW: "bought_bandwidth",
};

export const STATUS_COLOR = {
  FOR_SELL_OTHERS: "#fff", // white, #fff
  FOR_SELL: "#ebd02e", // yellow, #ebd02e
  SOLD: "#ff0219", // red, #ff0219
  UN_VERIFY: "#afafaf", // gray, #afafaf
  PURCHASED: "#17ce26", // green, #17ce26
  VERIFY: "#17ce26", // green, #17ce26
};

export enum PortColor {
  Red = "red",
  Yellow = "yellow",
  Green = "green",
  Grey = "grey",
  White = "white",
  LightGreen = "light-green",
  LightGrey = "light-grey",
  LightYellow = "light-yellow",
}

export const PORT_COLOR_MAP: Record<PortColor, string> = {
  [PortColor.Green]: "#17ce26",
  [PortColor.Red]: "#ff0219",
  [PortColor.Grey]: "#afafaf",
  [PortColor.Yellow]: "#ebd02e",
  [PortColor.White]: "#ffffff",
  [PortColor.LightGreen]: "#c1ffc5",
  [PortColor.LightGrey]: "#e5e5e5",
  [PortColor.LightYellow]: "#c1ffc5",
};

export const MAP_ZOOM = {
  maxScale: 15000000,
  minScale: 500,
};

export const MAP_COLOR = {
  GREY: "#4D4D4D", // dark grey
  YELLOW: "#E8D043", // dark yellow
  GREEN: "#43751D", // green
  RED: "#FF3A3A", // red
  WHITE: "#FFFFFF", // white
  BLACK: "#070504", // black
  LIGHT_GREEN: "#64AF29", // light green
};

export const mapIds = {
  MY_NETWORK: ["available", "consumed", "static"],
  MARKETPLACE: ["demand", "contract", "other"],
  available: "available",
  consumed: "consumed",
  static: "static",
  demand: "demand",
  contract: "contract",
  other: "other",
};

export const mapFilterDescriptions = {
  available: "Bandwidth that is on WaveXchange and is not currently in a circuit.",
  consumed: "Bandwidth that is on WaveXchange and is in a circuit (green) or listed (yellow).",
  static: "Bandwidth that is either sold by your company on the marketplace OR it is not registered with WaveXchange",
  demand: "Bandwidth that is for sale on the marketplace on demand.",
  contract: "Bandwidth that is for sale on the marketplace on contract.",
  other: "Bandwidth that exists outside of your companies network",
};

export const mapFilterNames = {
  available: "Available",
  consumed: "Consumed",
  static: "Offline",
  demand: "On Demand",
  contract: "On Contract",
  other: "Other",
};

export type countType = {
  verified: number;
  listed: number;
  bought: number;
  sold: number;
  unverified: number;
};

export type addNEType = {
  name: string;
  street: string;
  country: string;
  state: string;
  city: string;
  zip: string;
  longitude: string;
  latitude: string;
};

export type editNEPayload = {
  name: string;
  street: string;
  country: string;
  state: string;
  city: string;
  zip: string;
  neId: number;
  nodeId: number;
  longitude: string;
  latitude: string;
};
